import { createLoanAppConfig } from "@clcdev/gatsby-theme-application";
import meta from "./meta";

const APP_CONFIG_VARIANT = process.env.GATSBY_APP_CONFIG_VARIANT;

export default createLoanAppConfig(
    APP_CONFIG_VARIANT || "credit-classic",
    meta,
);